module.exports = __webpack_public_path__ + "img/pic_suanlishichang.a0ba3496.png";